var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CesiumIon3DTilesAsset } from "./CesiumIon3DTilesAsset";
import { CesiumIonGLTFAsset } from "./CesiumIonGLTFAsset";
import { CesiumIonImageryAsset } from "./CesiumIonImageryAsset";
import { CesiumIonTerrainAsset } from "./CesiumIonTerrainAsset";
import { CesiumIonKMLAsset } from "./CesiumIonKMLAsset";
import { CesiumIonCZMLAsset } from "./CesiumIonCZMLAsset";
import { CesiumIonGeoJSONAsset } from "./CesiumIonGeoJSONAsset";
/**
 * This function handles a fetched CesiumIonAssetEndpoint and will produce an appropriate CesiumIonAsset sub-class
 * for the type of asset available at the endpoint.
 *
 * @param endpoint
 */
export function assetFromEndpoint(endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
        // While apparently the REST docs allow these to be undefined, we require all 3 fields to be present. If they
        // aren't then we return undefined as we can't produce an asset otherwise
        if (typeof endpoint.type === "undefined") {
            throw new Error("CesiumIonAssetEndpoint does not have enough data to determine endpoint type");
        }
        switch (endpoint.type) {
            case "3DTILES" /* CesiumIonAssetType.Tiles */:
                return yield CesiumIon3DTilesAsset.fromEndpoint(endpoint);
            case "GLTF" /* CesiumIonAssetType.Gltf */:
                return yield CesiumIonGLTFAsset.fromEndpoint(endpoint);
            case "IMAGERY" /* CesiumIonAssetType.Imagery */:
                return yield CesiumIonImageryAsset.fromEndpoint(endpoint);
            case "TERRAIN" /* CesiumIonAssetType.Terrain */:
                return yield CesiumIonTerrainAsset.fromEndpoint(endpoint);
            case "KML" /* CesiumIonAssetType.Kml */:
                return yield CesiumIonKMLAsset.fromEndpoint(endpoint);
            case "CZML" /* CesiumIonAssetType.Czml */:
                return yield CesiumIonCZMLAsset.fromEndpoint(endpoint);
            case "GEOJSON" /* CesiumIonAssetType.GeoJson */:
                return yield CesiumIonGeoJSONAsset.fromEndpoint(endpoint);
            default:
                throw new Error("The endpoint declared an unknown asset type");
        }
    });
}
export * from "./CesiumIonAsset";
export * from "./CesiumIon3DTilesAsset";
export * from "./CesiumIonCZMLAsset";
export * from "./CesiumIonGeoJSONAsset";
export * from "./CesiumIonGLTFAsset";
export * from "./CesiumIonImageryAsset";
export * from "./CesiumIonKMLAsset";
export * from "./CesiumIonTerrainAsset";
